// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"142":"90c36b72","190":"5539e753","324":"8d4f9d52","593":"3aea2422","655":"313092db","699":"6cc267f3","825":"afe49af8"}[chunkId] + ".chunk.js";
};